/**
 * Labstep
 *
 * @module components/Metadata/Form/ShowEdit/File
 * @desc Metadata showdit for file
 */

import FileActionCreate from 'labstep-web/components/File/Action/Create';
import { FileActionUploadContainer as FileActionUpload } from 'labstep-web/components/File/Action/Upload';
import { UpdateOrCreate as UpdateOrCreateContainer } from 'labstep-web/containers/UpdateOrCreate';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import type { IOnSuccessProps } from 'labstep-web/models/action.model';
import { Protocol } from 'labstep-web/models/protocol.model';
import type React from 'react';
import type { MetadataFormShowEditFileProps } from './types';

export const MetadataFormShowEditFile: React.FC<
  MetadataFormShowEditFileProps
> = ({
  createProps,
  metadata,
  entity,
  isDropzone,
  actionComponentType = 'text',
}) => {
  return (
    <UpdateOrCreateContainer
      createProps={createProps}
      entityName={metadata.entityName}
      updateProps={{ id: metadata.id }}
      // Need this cause even though we are sending file_id
      // the field we are changing is "files"
      optimistic={false}
    >
      {({ action, status }) => {
        const options: any = {
          onSuccess: ({ response }: IOnSuccessProps) => {
            const fileId = Array.isArray(response.result)
              ? response.result[0]
              : response.result;
            action({
              file_id: fileId,
            } as any);
          },
        };
        return isDropzone ? (
          <FileActionUpload options={options} multiple={isDropzone} />
        ) : (
          <FileActionCreate
            multiple
            onFolderWatcherSelect={({ file }) => {
              action({ file_id: file.id } as any);
            }}
            options={options}
          >
            {({ toggleModal }) =>
              actionComponentType === 'icon' ? (
                <ActionComponent
                  type="icon"
                  status={status}
                  onClick={toggleModal}
                  icon="plus"
                  elementProps={{ popup: { content: 'Add more' } }}
                />
              ) : (
                <ActionComponent
                  type="text"
                  status={status}
                  onClick={toggleModal}
                  elementProps={{ showEdit: true }}
                  text={
                    (metadata.is_template ||
                      entity instanceof Protocol) &&
                    !createProps
                      ? 'Select / upload default file'
                      : 'Select / upload file(s)'
                  }
                />
              )
            }
          </FileActionCreate>
        );
      }}
    </UpdateOrCreateContainer>
  );
};
